import { useState, useCallback } from "react";

// 自定义 useLoadMore Hook
const useLoadMore = (fetchData: any, initialPage = 1, pageSize = 5) => {
    const [data, setData] = useState<any[]>([]);
    const [page, setPage] = useState(initialPage);
    const [isLoading, setIsLoading] = useState(false);
    const [hasMore, setHasMore] = useState(false);
    const [isRefreshing, setIsRefreshing] = useState(false);

    // 加载数据的函数
    const loadMore = useCallback(async () => {
        if (isLoading || !hasMore) return;

        setIsLoading(true);

        try {
            const result = await fetchData(page, pageSize);
            if (result.length < pageSize) {
                setHasMore(false); // 没有更多数据了
            }
            setData((prevData: any[]) => [...prevData, ...result]);
            setPage((prevPage) => prevPage + 1);
        } finally {
            setIsLoading(false);
        }
    }, [page, pageSize, fetchData, isLoading, hasMore]);

    // 下拉刷新功能
    const refresh = useCallback(async () => {
        if (isRefreshing) return;

        setIsRefreshing(true);
        setPage(initialPage); // 重置页码

        try {
            const result = await fetchData(initialPage, pageSize);
            setData(result);
            setHasMore(result.length >= pageSize); // 如果数据少于 pageSize，则说明没有更多了
            setPage((prevPage) => prevPage + 1);
        } finally {
            setIsRefreshing(false);
        }
    }, [fetchData, initialPage, pageSize, isRefreshing]);

    return {
        data,          // 当前已加载的数据
        isLoading,     // 是否正在加载更多
        loadMore,      // 手动加载更多
        refresh,       // 手动刷新
        isRefreshing,  // 是否正在刷新
        hasMore        // 是否有更多数据
    };
};

export default useLoadMore;
